module.exports = __webpack_public_path__ + "img/bolt-solid.136575b4.svg";